var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeesOneTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7106 16.2467L14.7562 5.92624L17.182 1.26187C17.3213 0.994147 17.3107 0.673176 17.1541 0.415208C16.9975 0.15724 16.7176 -0.000244141 16.4159 -0.000244141C14.5602 -0.000244141 13.6195 0.281647 12.7099 0.554297C11.883 0.802074 11.1021 1.03612 9.49969 1.03612C7.89729 1.03612 7.11635 0.802074 6.28955 0.554297C5.37988 0.281647 4.43921 -0.000244141 2.58356 -0.000244141C2.28176 -0.000244141 2.0019 0.15724 1.84532 0.415208C1.68874 0.673176 1.67812 0.994147 1.81738 1.26187L4.24321 5.92629L0.28879 16.2467C-0.794944 19.0751 1.30231 22.1088 4.32478 22.1088H14.6746C17.704 22.1088 19.7921 19.0691 18.7106 16.2467ZM4.04902 1.80946C4.76078 1.89928 5.26795 2.05128 5.79374 2.20885C6.7034 2.4815 7.64403 2.76339 9.49969 2.76339C11.3553 2.76339 12.296 2.4815 13.2057 2.20885C13.7315 2.05128 14.2386 1.89928 14.9504 1.80946L13.2865 5.00885H5.71294L4.04902 1.80946ZM14.6746 20.3816H4.32478C2.50544 20.3816 1.24954 18.5667 1.90163 16.8648L5.7826 6.73612H13.2168L17.0977 16.8647C17.7485 18.5632 16.4972 20.3816 14.6746 20.3816Z",
    fill: "#9C92E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeesOneTime);
export default __webpack_public_path__ + "static/media/fees_one_time.6f58fd218bdf5cdd48ff85788d365a30.svg";
export { ForwardRef as ReactComponent };